<div
  *ngIf="enableSpinner"
  class="spinner__overlay"
  [class.spinner__overlay--fixed]="fullscreen"
>
  <div class="spinner">
    <mat-spinner color="accent"></mat-spinner>
    <p class="spinner__text" *ngIf="spinnerText">{{ spinnerText }}</p>
  </div>
</div>
